import React from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { type WithTranslation } from '../../../types/common.types';
import { AiSubActionsProps } from '../../../types/sidePanel.types';
import HamburgMenuComp from '../../../../components/hamburgmenu';
import { getAiTypeAttributes, getStateComponentIcon } from '../../../utils';

export default withTranslation()(class AiSubActionsComp extends React.Component<WithTranslation<AiSubActionsProps>> {
  constructor(props: WithTranslation<AiSubActionsProps>) {
    super(props);
    this.submitAddSubAi = this.submitAddSubAi.bind(this);
    this.deleteAiClick = this.deleteAiClick.bind(this);
  }

  submitAddSubAi(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (e.keyCode == 13 && e.shiftKey == false) {
      const _this = this;
      const subActText = (e.target as HTMLTextAreaElement).value.trim();
      if (subActText == '') {
        return;
      }
      $(_this.refs.wsBoardAddSubAi).val('');
      this.props.addAiSubAction(subActText);
    }
  }

  deleteAiClick(item: { id: any; parent: any; }) {
    const _this = this;
    _this.props.deleteAiClick(item);
    _this.props.removeSubAi(item.id);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="wsBoardAiSubActWrapper">
        <div className="wsBoardSubAiAddDiv">
          <textarea
            autoFocus
            ref="wsBoardAddSubAi"
            className="wsBoardAiSubActEditor"
            placeholder={t("Type a subtask and press enter")}
            onKeyDown={event => this.submitAddSubAi(event)}
          />
        </div>
        <div className="wsBoardSubAiListDiv">
          {this.props.aiSubActions != null
            && Object.keys(this.props.aiSubActions).length
            ? Object.keys(this.props.aiSubActions).map((item, index) => (
              <WsBoardSubActListComp
                isLoading={this.props.aiSubActions[item].id.includes('newAi_')}
                key={this.props.aiSubActions[item].id}
                startAccess={this.props.startAccess}
                deleteAiClick={this.deleteAiClick}
                subAiConvClick={this.props.subAiConvClick}
                subAiDet={this.props.aiSubActions[item]}
                openAiDetailPopup={this.props.openAiDetailPopup}
                t={t}
              />
            ))
            : ''}
        </div>
      </div>
    );
  }
});

type SubAiDetProps = {
  state: string;
  id: string;
  desc: string;
  ownerName: string;
  due_date_text: string;
  type: string
}

type WsBoardSubActListCompProps = {
  isLoading: boolean;
  subAiConvClick: any;
  subAiDet: SubAiDetProps;
  deleteAiClick: any;
  openAiDetailPopup: (arg0: any, arg1: string) => void;
  startAccess: boolean;
  t: any
}
const WsBoardSubActListComp = ({
  isLoading,
  subAiConvClick,
  subAiDet,
  deleteAiClick,
  openAiDetailPopup,
  startAccess,
  t
}: WsBoardSubActListCompProps) => {

  const menu: any = {};
  menu.items = [
    {
      title: t('Convert to action item'),
      handler: subAiConvClick,
      imageclass: 'aiClick',
      pic: 'convert_to_action',
      item: subAiDet
    }
  ];

  menu.items.push({
    title: t('Delete'),
    handler: deleteAiClick,
    class: 'deleteAi',
    pic: 'delete_img',
    item: subAiDet
  });

  const loadingClassname = isLoading ? 'wsBoardSubAiDivLoading' : '';
  const { attributes } = getAiTypeAttributes(subAiDet.type);
  const iconComponentName = getStateComponentIcon(attributes?.state?.values ?? [], subAiDet.state);

  return (
    <div className={`wsBoardSubAiDiv displayTable w100 tabLayFix ${loadingClassname}`}>
      <div className="displayRow">
        <div
          className="displayCell wbBoardSubAiStateIcon"
        >
          <Icon name={iconComponentName} width="18" height="18" />
        </div>
        <div
          className="displayCell wsBoardSubAiDescDiv clickable"
          onClick={() =>
            openAiDetailPopup(subAiDet.id, 'wsBoardSubAiDescDiv')}
        >
          {subAiDet.desc}
        </div>
        <div className="displayCell wsBoardSubAiOwnerDiv">
          {subAiDet.ownerName}
        </div>
        <div className="displayCell wsBoardSubAiDueDiv">
          {subAiDet.due_date_text}
        </div>
        {startAccess && (
          <div
            className="wsBoardAiKebebDiv clickable"
            data-value={subAiDet.id}
            style={{ paddingBottom: '4px' }}
          >
            <HamburgMenuComp
              key={`sub_action_${subAiDet.id}`}
              menu={menu}
            />
          </div>
        )}
      </div>
    </div>
  );
};
